import { render, staticRenderFns } from "./ProsumerBonus.vue?vue&type=template&id=bed623ee"
import script from "./ProsumerBonus.vue?vue&type=script&lang=ts"
export * from "./ProsumerBonus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports